// extracted by mini-css-extract-plugin
export default {"presenter":"VideoPresenter_presenter__Tj3AA","presenterIcon":"VideoPresenter_presenterIcon__H3GPi"};